import { createContext } from '@fluentui/react-context-selector';
export var ChatItemContext = createContext({
  attached: false
}, {
  strict: false
});
export var ChatItemContextProvider = ChatItemContext.Provider;
//# sourceMappingURL=chatItemContext.js.map
